module.exports = __webpack_public_path__ + "static/media/brnr.6508d536.svg";